<template>
  <div
    v-if="breadcrumbs"
    class="breadcrumbs"
    :class="className"
  >
    <ul class="breadcrumbs__list">
      <!--      <li -->
      <!--        v-if="backIcon" -->
      <!--        class="breadcrumbs__item breadcrumbs__item&#45;&#45;back" -->
      <!--      > -->
      <!--        <AppLink -->
      <!--          :to="backLink" -->
      <!--          class="breadcrumbs__link" -->
      <!--        > -->
      <!--          <IconArrowShort class="icon icon&#45;&#45;arrow-left" /> -->
      <!--        </AppLink> -->
      <!--      </li> -->
      <li class="breadcrumbs__item breadcrumbs__item--home">
        <AppLink
          :to="backLink"
          class="breadcrumbs__link"
        >
          <span>{{ $t('Home') }}</span>
        </AppLink>
      </li>
      <template v-if="breadcrumbs?.parents">
        <li
          v-for="(parent, index) in (breadcrumbs.parents)"
          :key="index"
          class="breadcrumbs__item"
        >
          <AppLink
            v-if="parent && parent.url"
            :to="'/' + parent.url"
            class="breadcrumbs__link"
          >
            <span>{{ parent.label }}</span>
          </AppLink>
        </li>
      </template>
      <li
        v-if="breadcrumbs.label"
        class="breadcrumbs__item"
      >
        <span class="breadcrumbs__label">{{ breadcrumbs.label }}</span>
      </li>
    </ul>
    <AppLink
      v-if="isLoggedIn"
      to="/account/"
      class="logout-link"
      @click="logout"
    >
      <span>{{ $t('Sign out') }}</span>
    </AppLink>
  </div>
  <div v-else />
</template>

<script lang="ts" setup>
const { breadcrumbs } = useBreadcrumbs()
const { isLoggedIn } = useAccount()
const { logout } = useAccountLogout()

defineProps({
  className: {
    type: String,
    default: '',
  },
  backLink: {
    type: String,
    default: '/',
  },
  backIcon: {
    type: Boolean,
    default: false,
  },
})
</script>

<style src="~layers/app/components/App/Breadcrumbs.css" />
